import { render, staticRenderFns } from "./PositionSelect.vue?vue&type=template&id=b5bedcb8&"
import script from "./PositionSelect.vue?vue&type=script&lang=ts&"
export * from "./PositionSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports